import { IMedicalOrder } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { MedicalOrderWorkItem } from 'src/app/business/medical-order/medical-order-work-item';
import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class MedicalOrderCommandHandler extends EntityCommandHandler<IMedicalOrder> {
  protected workItem: IWorkItem<IMedicalOrder>;

  constructor(medicalOrderWorkItem: MedicalOrderWorkItem) {
    super();
    this.workItem = medicalOrderWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'MedicalOrderDto';
  }
}
